var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import merge from 'lodash/merge';
import { defaultApiHost } from '@src/helpers';
import { stringify } from '@src/utils/qs';
import { getSession } from './session';
const fetchDefaults = {
    cache: 'no-cache',
    credentials: 'include',
    mode: 'cors',
    headers: {
        'Content-Type': 'application/json',
    },
};
const resolveUrl = (url, baseUrl) => url.startsWith('/') && !url.startsWith('//') ? baseUrl + url : url;
export const fetcher = ({ url, query, fetchParams = {}, baseUrl = defaultApiHost, }) => __awaiter(void 0, void 0, void 0, function* () {
    fetchParams = Object.assign(Object.assign({}, fetchDefaults), fetchParams);
    const { session } = yield getSession();
    if (session === null || session === void 0 ? void 0 : session.token) {
        fetchParams = merge(fetchParams, {
            headers: {
                Authorization: `Bearer ${session.token}`,
            },
        });
    }
    const queryPrefix = url.includes('?') ? '&' : '?';
    return fetch(resolveUrl(url, baseUrl) + queryPrefix + stringify(query), fetchParams);
});
